import React from 'react'

import Navbar from '../navbar'
import Footer from '../footer'
import WhatsappButton from '../whatsappButton'

function Layout(props) {
  // const children = props.children;
  return (
    <React.Fragment>
      <Navbar />
      <div className="bodyPage espacioAbajo">
        {props.children}
      </div>
      <WhatsappButton />
      <Footer />
    </React.Fragment>
  )
}

export default Layout;